const isLocalhost = window.location.hostname === "localhost";
const defaultApiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ?? "https://find-jazz-concerts.onrender.com";

const tipLink =
  process.env.REACT_APP_TIP_LINK ??
  "https://buy.stripe.com/cNibJ1aFF5YU72w9lh9oc00";

export const API_BASE_URL = isLocalhost
  ? "http://127.0.0.1:8000"
  : defaultApiBaseUrl;

export const TIP_LINK = tipLink;
